import { Pipe, PipeTransform } from '@angular/core';

const DEFAULT_LICENSE_LABEL = 'Lic. #';

/**
 * Mirrors ProjulV1Portal's licenseLabel pipe for this English-only app: the document's own label, else
 * the default label. The legacy stored default is the same text as the English default, so it needs no case.
 */
@Pipe({ name: 'licenseLabel' })
export class LicenseLabelPipe implements PipeTransform {
  transform(saved: string | null | undefined): string {
    return (saved ?? '').toString().trim() || DEFAULT_LICENSE_LABEL;
  }
}
